"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Driver = {
  edit: false,
  hash: '',
  $form: undefined,
  previewFiles: [],
  serviceID: undefined,
  callbackUrl: undefined,
  secondBlockAvailableForFetch: true,
  // to save the information in the second step if the types are unchanged
  thirdBlockAvailableForFetch: true,
  // to save the information in the third step if the types are unchanged
  onload: document.addEventListener('DOMContentLoaded', function () {
    Driver.init();
  }),
  init: function init() {
    this.bind();
    Autocomplete.googleAutocompleteForDriver.autocompleteField();
  },
  bind: function bind() {
    $(document).on('click', 'input.choose-type-service', function () {
      var driverCheck = $('[name="driver_service_default"]').is(':checked') ? 1 : 0;
      var indoorCheck = $('[name="driver_service_indoor"]').is(':checked') ? 1 : 0;
      var outdoorCheck = $('[name="driver_service_outdoor"]').is(':checked') ? 1 : 0;
      Driver.ajax.fetchBlockForFirstStepByType(driverCheck, indoorCheck, outdoorCheck);
    }).on('click', '.checkbox-driver', function () {
      var driverSelect = $(this).closest('.select-driver');
      var blockWithSelectedItems = driverSelect.find('.selected-items');
      var dataId = $(this).attr('id');
      if ($(this).is(':checked')) {
        var title = $(this).next().html();
        var html = "<div class=\"form-step__job\" data-item-id=\"".concat(dataId, "\">").concat(title, "<svg data-id=\"").concat(dataId, "\" width=\"12\" height=\"11\" viewBox=\"0 0 12 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 0.5L6 5.5M11 10.5L6 5.5M6 5.5L11 0.5M6 5.5L1 10.5\" stroke=\"white\" stroke-linecap=\"round\" /></svg></div>");
        blockWithSelectedItems.prepend(html);
      } else {
        blockWithSelectedItems.find("[data-item-id=\"".concat(dataId, "\"]")).remove();
      }
      Driver.everythingElseServiceBlock(driverSelect.find('.service-everything-else'), dataId);
      $(this).closest('.select-driver__wrapper').removeClass('error').find('.select-driver__error').html('');
      Driver.setSelectJson(driverSelect);
    }).on('click', '.form-step__job svg', function () {
      var everythingElseBlock = $(this).closest('.select-driver').find('.service-everything-else');
      var dataId = parseInt($(this).attr('data-id'));
      $("#" + dataId).prop('checked', false);
      Driver.setSelectJson($(this).closest('.select-driver'));
      $(this).closest('div').remove();
      Driver.everythingElseServiceBlock(everythingElseBlock, dataId);
    }).on('click', '.upload-photo-btn', function (e) {
      e.preventDefault();
      Driver.selectFiles($(this));
    }).on('click', 'ul.upload > li[data-id] > span.remove-upload-driver-photo', function (e) {
      e.preventDefault();
      Driver.files.remove($(this).closest('li[data-id]').data('id'));
      $('.upload-photo__block').show();
      $('.upload-photo-btn').show();
    }).on('click', '.search-service-checkbox', function () {
      var driverSelect = $(this).closest('.select-transports__pop-up');
      Driver.setSelectString(driverSelect);
    });
    $(document).on('click', 'button.submit-service-form', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      Driver.$form = $(this).closest('form[data-type]');
      Driver.ajax.sendServiceForm($(this));
    }).on('click', 'button.archive-driver-handyman-service', function (event) {
      event.preventDefault();
      $('.archive-vehicle').addClass('active');
      $('.archive-confirmation').attr('data-id', $(this).attr('data-id'));
    }).on('click', 'button.restore-driver-handyman-service', function (event) {
      event.preventDefault();
      var id = $(this).data('id');
      $('.restore-vehicle').show();
      $('.restore-confirmation').attr('data-id', id);
    }).on('click', 'button.delete-driver-handyman-service', function (event) {
      event.preventDefault();
      var id = $(this).data('id');
      $('.delete-vehicle').show();
      $('.delete-confirmation').attr('data-id', id);
    }).on('click', '.archive-confirmation', function (event) {
      event.preventDefault();
      var reason = $(this).closest('form').find('textarea').val();
      Driver.ajax.archiveService($(this).attr('data-id'), reason);
    }).on('click', '.delete-confirmation', function (event) {
      event.preventDefault();
      Driver.ajax.deleteService($(this).attr('data-id'));
    }).on('click', '.restore-confirmation', function (event) {
      event.preventDefault();
      Driver.ajax.restoreService($(this).attr('data-id'));
    }).on('click', '.checked', function (event) {
      event.preventDefault();
      $(this).find('.checked-tooltips').show();
    }).on('mouseout', '.user__cart, .checked', function (event) {
      $(this).find('.checked-tooltips').hide();
    }).on('mouseover', '.checked', function (event) {
      $(this).find('.checked-tooltips').show();
    });
  },
  setSelectJson: function setSelectJson(select) {
    var inputGetJson = select.find('.get-json');
    var checkbox = select.find("input:checked");
    var searchIDs = [];
    checkbox.map(function () {
      searchIDs.push($(this).attr("id"));
    });
    var json = _objectSpread({}, searchIDs);
    inputGetJson.val(checkbox.length > 0 ? JSON.stringify(json) : '');
    checkbox.length > 0 ? select.find('.form-step__jobs').removeClass('margin-none') : select.find('.form-step__jobs').addClass('margin-none');
  },
  setSelectString: function setSelectString(select) {
    var inputGetJson = $('#search_services');
    var checkbox = select.find("input:checked");
    var searchIDs = [];
    checkbox.map(function () {
      searchIDs.push($(this).attr("id"));
    });
    var string = _objectSpread({}, searchIDs);
    inputGetJson.val(checkbox.length > 0 ? searchIDs.toString() : '');
    // checkbox.length > 0 ?
    //     select.find('.form-step__jobs').removeClass('margin-none') :
    //     select.find('.form-step__jobs').addClass('margin-none')
  },

  everythingElseServiceBlock: function everythingElseServiceBlock(block, id) {
    if (id == 10 || id == 24 || id == 29) {
      block.toggle();
      block.closest('.form-step__group').toggleClass('margin-none');
    }
  },
  showSelectedServicesForThirdStep: function showSelectedServicesForThirdStep() {
    var block = $('#selected-services');
    block.html('');
    $('.form-step__job').each(function () {
      var text = $(this).text();
      block.append("<div class=\"form-step__get-job\">".concat(text, "</div>"));
    });
  },
  selectFiles: function selectFiles(element) {
    Driver.$form = element.closest('form');
    var $input = $('<input type="file" accept=".png, .jpg, .jpeg, .HEIC" multiple>').on('change', function (event) {
      var preloderCount = true;
      var fileNmame = this.files[0];
      var fileNameExt = fileNmame.name.substr(fileNmame.name.lastIndexOf('.') + 1);
      var container;
      var fileJpeg;
      if (fileNameExt == "heic" || fileNameExt == "HEIC") {
        var thisInput = this;
        preloderCount = false;
        Step.preloaderUpload(event, preloderCount);
        // console.log('fileNmame', fileNmame);
        heic2any({
          blob: fileNmame,
          toType: "image/jpeg",
          quality: 0.5
        }).then(function (result) {
          console.log('result', result);
          container = new DataTransfer();
          fileJpeg = new File([result], fileNmame.name + ".jpg", {
            type: "image/jpeg",
            lastModified: new Date().getTime()
          });
          container.items.add(fileJpeg);
          $.each(thisInput.files, function () {
            if (fileJpeg.size < Step.maxFileSize && Driver.files.list.length < 20) {
              Driver.files.add(container.files[0]);
              Driver.previewFiles.push(URL.createObjectURL(result));
            }
          });
        })["catch"](function (x) {
          // console.log('erro-1', x.code);
          // console.log('erro-2', x.message);
          // console.log('x', x);
        });
      } else {
        preloderCount = true;
        Step.preloaderUpload(event, preloderCount);
        $.each(this.files, function (k, v) {
          if (v.size < Step.maxFileSize && Driver.files.list.length < 20) {
            Driver.files.add(v);
            Driver.previewFiles.push(URL.createObjectURL(event.target.files[k]));
          }
        });
      }

      // $.each(this.files, function (k, v) {
      //     if (v.size || fileJpeg.size < Step.maxFileSize && Driver.files.list.length < 20) {
      //         Driver.files.add(v || container.files[0]);
      //         Driver.previewFiles.push(URL.createObjectURL(event.target.files[k]));
      //     }
      // });

      $input.remove();
      if (Driver.files.list.length > 19) {
        $('.upload-photo__block').hide();
        $('.upload-photo-btn').hide();
      } else {}
      $('.upload-photo').removeClass('error');
      $('.upload-photo__error').html('');
    }).hide();
    $(document.body).append($input);
    $input.click();
  },
  manageExtraHelperBlocks: function manageExtraHelperBlocks() {
    if (parseInt($('#max-helpers').val()) > 0) {
      $('.extra-helper-block').show();
    } else {
      $('.extra-helper-block').hide();
    }
  },
  files: {
    list: [],
    $fileList: undefined,
    $progress: undefined,
    add: function add(file) {
      this.list.push(file);
      this.refreshList();
    },
    remove: function remove(key) {
      this.list.splice(key, 1);
      Driver.previewFiles.splice(key, 1);
      this.refreshList();
    },
    refreshList: function refreshList(callback) {
      this.$fileList = Driver.$form.find('ul.upload').fadeOut('fast', function () {
        $(this).children('li').remove();
        $.each(Driver.files.list, function (k, v) {
          Driver.files.$fileList.append($('<li>').attr('data-id', k).append($('<img>').addClass('open-image').attr('src', Driver.previewFiles[k])).append('<span class="remove-upload-driver-photo"><svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="10.5" cy="10" rx="10.5" ry="10" fill="white" fill-opacity="0.8"/><path d="M6 5L11 10M16 15L11 10M11 10L16 5M11 10L6 15" stroke="#EB5757" stroke-width="2"/></svg>\n</span>'));
        });
        $(this).fadeIn('fast', function () {
          typeof callback === 'function' ? callback() : null;
        });
      });
    },
    upload: function upload() {
      if (this.list.length > 0) {
        Driver.ajax.uploadFilesForService(this.list.shift());
      } else {
        var thankYouPage = $('div.thank-form-step');
        thankYouPage.css('display', 'flex');
        $('div.offer__container').hide();
        if ($('[name="driver_service_default"]').is(':checked')) {
          thankYouPage.find('img').attr('src', '/images/Picture_car.png');
        } else {
          thankYouPage.find('img').attr('src', '/images/Phone_maintenance-pana.png');
        }
        Step.scrollToTop();
      }
    }
  },
  ajax: {
    obj: {},
    url: DRIVER_AJAX_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON');
    },
    fetchBlockForFirstStepByType: function fetchBlockForFirstStepByType(driverCheck, indoorCheck, outdoorCheck) {
      this.obj.method = 'fetchBlockForFirstStepByType';
      this.obj.edit = Driver.edit;
      this.obj.hash = Driver.hash;
      this.obj.typeDriver = driverCheck;
      this.obj.typeIndoor = indoorCheck;
      this.obj.typeOutdoor = outdoorCheck;
      this.send(function (answer) {
        $('#block-for-first-step-by-type').html(answer.html);
        Driver.secondBlockAvailableForFetch = true;
        Driver.thirdBlockAvailableForFetch = true;
        Driver.files.list = [];
        Step.collectionDataForCalculatorOnTips($('.form-step__step').first().find('.form-step__next').attr('data-step'));
      }, function (answer) {
        console.log('Error');
      });
    },
    fetchBlockForSecondStepByType: function fetchBlockForSecondStepByType() {
      this.obj.method = 'fetchBlockForSecondStepByType';
      this.obj.edit = Driver.edit;
      this.obj.hash = Driver.hash;
      this.obj.typeDriver = $('[name="driver_service_default"]').is(':checked') ? 1 : 0;
      this.obj.typeIndoor = $('[name="driver_service_indoor"]').is(':checked') ? 1 : 0;
      this.obj.typeOutdoor = $('[name="driver_service_outdoor"]').is(':checked') ? 1 : 0;
      this.send(function (answer) {
        $('#block-for-second-step-by-type').html(answer.html);
        Driver.secondBlockAvailableForFetch = false;
        Autocomplete.googleAutocompleteForDriver.autocompleteField();
        Step.collectionDataForCalculatorOnTips($('#block-for-second-step-by-type').closest('.form-step__step').find('.form-step__next').attr('data-step'));
      }, function (answer) {
        console.log('Error');
      });
    },
    fetchBlockForThirdStepByType: function fetchBlockForThirdStepByType() {
      this.obj.method = 'fetchBlockForThirdStepByType';
      this.obj.edit = Driver.edit;
      this.obj.hash = Driver.hash;
      this.obj.typeDriver = $('[name="driver_service_default"]').is(':checked') ? 1 : 0;
      this.obj.typeIndoor = $('[name="driver_service_indoor"]').is(':checked') ? 1 : 0;
      this.obj.typeOutdoor = $('[name="driver_service_outdoor"]').is(':checked') ? 1 : 0;
      this.send(function (answer) {
        $('#block-for-third-step-by-type').html(answer.html);
        Driver.thirdBlockAvailableForFetch = false;
        Driver.manageExtraHelperBlocks();
        Step.collectionDataForCalculatorOnTips($('#block-for-third-step-by-type').closest('.form-step__step').find('.form-step__next').attr('data-step'));
      }, function (answer) {
        console.log('Error');
      });
    },
    archiveService: function archiveService(hash, reason) {
      this.obj.method = 'archiveService';
      this.obj.hash = hash;
      this.obj.reason = reason;
      this.send(function (answer) {
        var archiveButton = $('.archive-driver-handyman-service');
        if (archiveButton.attr('data-page') === 'listing') {
          $('#driver-handyman-my-services-body').html(answer.html);
        } else {
          archiveButton.remove();
        }
        $('.archive-vehicle').removeClass('active');
        $('div.success-saved').addClass('active');
        setTimeout(function () {
          $('.pop-up').removeClass('active').find('button.archive-confirmation').attr('data-id', '');
        }, 1500);
      }, function (answer) {
        console.log('Error');
      });
    },
    restoreService: function restoreService(hash) {
      this.obj.method = 'restoreService';
      this.obj.hash = hash;
      this.send(function (answer) {
        $('#driver-handyman-my-services-body').html(answer.html);
        $('.restore-vehicle').hide();
        $('div.success-saved').addClass('active');
        setTimeout(function () {
          $('.pop-up').removeClass('active').find('button.restore-confirmation').attr('data-id', '');
        }, 1500);
      }, function (answer) {
        console.log('Error');
      });
    },
    deleteService: function deleteService(hash) {
      this.obj.method = 'deleteService';
      this.obj.hash = hash;
      this.send(function (answer) {
        $('#driver-handyman-my-services-body').html(answer.html);
        $('.delete-vehicle').hide();
        $('div.success-saved').addClass('active');
        setTimeout(function () {
          $('.pop-up').removeClass('active').find('button.delete-confirmation').attr('data-id', '');
        }, 1500);
      }, function (answer) {
        console.log('Error');
      });
    },
    uploadFilesForService: function uploadFilesForService(file) {
      var formData = new FormData();
      formData.append('method', 'uploadFilesForService');
      formData.append('id', Driver.serviceID);
      formData.append('file', file);
      $.ajax({
        url: AJAX_URL,
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        success: function success() {
          Driver.files.upload();
        },
        error: function error() {
          console.log('Error');
        }
      });
    },
    sendServiceForm: function sendServiceForm($submitBtn) {
      this.obj.method = 'sendServiceForm';
      this.obj.typeID = parseInt(Driver.$form.data('type'));
      this.obj.data = Driver.$form.serializeArray();
      this.obj.edit = parseInt(Driver.$form.data('edit'));
      this.obj.hash = Driver.$form.data('id');
      this.send(function (answer) {
        Driver.serviceID = answer.serviceID;
        Driver.callbackUrl = answer.callbackUrl;
        Driver.files.upload();
      }, function (answer) {
        $('.captcha > img').click();
        $('[name="captcha"]').val('');
        $.each(answer.errors, function (k, v) {
          Driver.$form.find("[name=\"".concat(k, "\"]")).closest('div').find('.error').show().html(v);
        });
        Main.hidePreloader($submitBtn);
        if (answer.savingError) Notify.dangerNotification(answer.savingError);
        if (!answer.phoneVerification) VerifyPhone.openFirstStep();
      });
    }
  }
};